import { format, parseISO } from "date-fns";

const W = 1080, H = 1080;

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function fitText(ctx, text, maxWidth, weight, family, startSize, minSize = 40) {
  let size = startSize;
  do { ctx.font = `${weight} ${size}px ${family}`; if (ctx.measureText(text).width <= maxWidth) break; size -= 4; } while (size > minSize);
}

const loadImage = (src) => new Promise((resolve) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = src;
});

export async function renderBookingCard(booking, { clubName = "D&D Padel", logoUrl = "/dd-logo-v2.png", kind = "court" } = {}) {
  await Promise.all([
    document.fonts.load("900 80px Outfit"), document.fonts.load("700 48px Outfit"),
    document.fonts.load("600 36px Manrope"), document.fonts.load("500 30px Manrope"),
  ]).catch(() => {});
  const logo = await loadImage(logoUrl);

  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");

  const bg = ctx.createLinearGradient(0, 0, W, H);
  bg.addColorStop(0, "#0B1220"); bg.addColorStop(1, "#123A2D");
  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);

  ctx.globalAlpha = 0.22;
  ctx.fillStyle = "#1F5F4A";
  ctx.beginPath(); ctx.arc(W - 120, 140, 320, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = "#EBBE4C";
  ctx.beginPath(); ctx.arc(140, H - 120, 260, 0, Math.PI * 2); ctx.fill();
  ctx.globalAlpha = 1;

  ctx.fillStyle = "rgba(255,255,255,0.06)";
  roundRect(ctx, 80, 80, W - 160, H - 160, 48); ctx.fill();
  ctx.strokeStyle = "rgba(255,255,255,0.12)"; ctx.lineWidth = 2; ctx.stroke();

  if (logo) {
    ctx.save(); roundRect(ctx, 140, 140, 140, 140, 32); ctx.clip();
    ctx.drawImage(logo, 140, 140, 140, 140); ctx.restore();
  }
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "#EBBE4C"; fitText(ctx, clubName, W - 450, 900, "Outfit", 84);
  ctx.fillText(clubName, 310, 232);
  ctx.fillStyle = "rgba(255,255,255,0.7)"; ctx.font = "500 30px Manrope";
  ctx.fillText("8 Ave de la Montagne, Morc Blackrock, Tamarin", 310, 278);

  ctx.strokeStyle = "rgba(255,255,255,0.12)"; ctx.beginPath(); ctx.moveTo(140, 340); ctx.lineTo(W - 140, 340); ctx.stroke();

  const label = (t, y) => { ctx.fillStyle = "rgba(255,255,255,0.55)"; ctx.font = "600 28px Manrope"; ctx.fillText(t.toUpperCase(), 140, y); };
  label(kind === "court" ? "Court booking" : `Lesson with ${booking.coach_name || "coach"}`, 420);
  ctx.fillStyle = "#FFFFFF"; fitText(ctx, format(parseISO(booking.date), "EEEE d MMMM yyyy"), W - 280, 700, "Outfit", 72);
  ctx.fillText(format(parseISO(booking.date), "EEEE d MMMM yyyy"), 140, 505);

  label("Time", 600);
  ctx.fillStyle = "#EBBE4C"; fitText(ctx, `${booking.start_time} – ${booking.end_time}`, W - 280, 900, "Outfit", 120);
  ctx.fillText(`${booking.start_time} – ${booking.end_time}`, 140, 720);

  label("Court", 810);
  ctx.fillStyle = "#8FC4AF"; ctx.font = "700 52px Outfit";
  ctx.fillText("Central Court · 60 min", 140, 870);

  if (booking.reference) {
    ctx.fillStyle = "rgba(255,255,255,0.5)"; ctx.font = "600 30px Manrope"; ctx.textAlign = "right";
    ctx.fillText(`Ref ${booking.reference}`, W - 140, 870); ctx.textAlign = "left";
  }

  ctx.fillStyle = "#EBBE4C"; ctx.font = "700 34px Outfit";
  ctx.fillText("See you on the court!", 140, 950);

  return canvas;
}

export async function shareBookingImage(booking, opts) {
  const canvas = await renderBookingCard(booking, opts);
  const blob = await new Promise(res => canvas.toBlob(res, "image/png"));
  const file = new File([blob], `dd-padel-${booking.date}.png`, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "D&D Padel booking" });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "cancelled";
    }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
  return "downloaded";
}
